import url from '../axios/apiUrl'
import {
  postRequest
} from "../api/index"
export default {
  // 因广告位设置的商品和活动商品无法知道商品的状态(如是否上下架)，所以需要提前请求商品详情
  // params:1代表各个专区的商品进去详情，0代表广告位设置的商品
  // cartBasketType:2表示特卖，4表示阶梯
  toDetails(v, _this, params) {
    let isJT = 0;
    let isSpecialSale = 0;
    // 利用购物车类型判断是特卖或阶梯
    if (v.cartBasketType == 2 || v.cartBasketType == 30) {
      isSpecialSale = 1
      sessionStorage.setItem("isSpecial", 1);
    } else if (v.cartBasketType == 4 || v.cartBasketType == 40) {
      isJT = 1;
    } else {
      isSpecialSale = 0
      isJT = 0
      sessionStorage.setItem("isSpecial", 0);
    }
    if (params == 1) {
      if (isJT == 1) {
        let routeData = _this.$router.resolve({
          path: "/ladderDetails",
          query: {
            id: v.id
          },
        });
        window.open(routeData.href, "_blank");
        // window.open(`http://192.168.1.184/#/ladderDetails?id=${v.id}`, '_blank')
        // window.open(`http://192.168.1.184/#/goodsDetails?id=${v.id}`, '_blank')
      } else {
        // let routeData = _this.$router.resolve({
        //   path: "/goodsDetails",
        //   query: {
        //     id: v.id
        //   },
        // });
        // window.open(routeData.href, "_blank");
        window.open(`http://192.168.1.184/#/goodsDetails?id=${v.id}`, '_blank')
      }
    } else if (params == 0) {
      sessionStorage.setItem('isSpecial', isSpecialSale)
      if (isJT == 1) {
        // let routeData = _this.$router.resolve({
        //     path: '/ladderDetails',
        //     query: { id: v.id },
        // })
        // window.open(routeData.href, '_blank')
        window.open(`this.link+"/#/"+"ladderDetails?id=${v.id}"`, "_blank")
      } else
        // let routeData = _this.$router.resolve({
        //     path: '/goodsDetails',
        //     query: { id: v.id },
        // })
        // window.open(routeData.href, '_blank')
        window.open(`http://192.168.1.184/#/goodsDetails?id=${v.id}`, '_blank')


      // postRequest(url.getGoodsById, {
      //     goodsId: v.id,
      //     specialSale: isSpecialSale,
      //     clientType: 1,
      //     tieredPrice: isJT,
      // }).then((res) => {
      // console.log(res,'---9999')
      // if (res.data.code == '000000') {
      //     sessionStorage.setItem('isSpecial', isSpecialSale)
      //     if (isJT != 0) {

      //         window.open('http://192.168.1.184/#/goodsDetails?id=v.id', '_blank')
      //     } else {

      //         window.open('http://192.168.1.184/#/goodsDetails?id=v.id', '_blank')
      //     }
      // } else if (res.data.message == '系统异常') {
      //     _this.$message({
      //         message: '网络异常，请稍后再试',
      //         offset: 400,
      //         duration: 2000,
      //         type: 'error',
      //         showClose: true,
      //     })
      // } else if (res.data.code != '000000') {
      //     _this.$message({
      //         message: res.data.message,
      //         offset: 400,
      //         duration: 3000,
      //         type: 'error',
      //         showClose: true,
      //     })
      // }
      // })
    }
  },
}



// WEBPACK FOOTER //
// ./src/config/toDetails.js